import * as Yup from 'yup';

export const userValidationSchema = Yup.object({
  first_name: Yup.string().required('Nome é obrigatório'),
  last_name: Yup.string().required('Sobrenome é obrigatório'),
  email: Yup.string().email('E-mail inválido').required('E-mail é obrigatório'),
//   cnpj: Yup.string()
//     .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/, 'CNPJ inválido')
//     .required('CNPJ é obrigatório'),
//   cep: Yup.string()
//     .matches(/^\d{5}-\d{3}$/, 'CEP inválido')
//     .required('CEP é obrigatório'),
//   number: Yup.string().required('Número é obrigatório'),
//   plan: Yup.string().oneOf(['1', '2', '3'], 'Plano inválido'),
//   contract_end:  Yup.string().required('A data de início de contrato é obrigatório'), 
//   contract_start:  Yup.string().required('A data de término de contrato é obrigatório'),
//   tr_balance: Yup.number().min(0, 'Valor inválido'),
//   hp_balance: Yup.number().min(0, 'Valor inválido'),
//   sr_balance: Yup.number().min(0, 'Valor inválido'),
//   cr_balance: Yup.number().min(0, 'Valor inválido'),
//   cm_balance: Yup.number().min(0, 'Valor inválido'),
//   hv_balance: Yup.number().min(0, 'Valor inválido'),
});
